import * as React from "react";
import cx from "classnames";

import Wrapper from "../Wrapper";
import "./Dropzone.css";

export interface DropzoneFile {
  name: string;
  url: string;
}

interface DropzoneContentProps {
  progress?: number;
  children: React.ReactChild | React.ReactChild[];
}

const DropzoneContent = ({ progress, children }: DropzoneContentProps) => (
  <Wrapper>
    <div
      className={cx("progress", {
        "progress--hidden":
          progress == null || progress >= 100 || progress <= 0,
      })}
    >
      <div className="progress-bar" style={{ width: `${progress}%` }} />
    </div>
    <div className="filelist">{children}</div>
  </Wrapper>
);

export default DropzoneContent;



// WEBPACK FOOTER //
// ./src/components/Dropzone/Content.tsx